import React, { useMemo } from 'react'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { Box, Typography } from 'transfix-ui/core'
import { ParserTestResult } from '../types'
import { TestResult } from './TestResult'

interface IParserTestResultsModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onClose: () => void
  parserTestResults: ParserTestResult[]
}

export const ParserTestResultsModal = ({
  onClose,
  parserTestResults,
  ...props
}: IParserTestResultsModalProps) => {
  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Close',
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  const numberPassingTests = useMemo(() => {
    return parserTestResults.filter(parserTestResult => parserTestResult.passed).length
  }, [parserTestResults])

  return (
    <ModalBase
      onClose={onClose}
      dataTest='ParserTestResultsModal'
      modalType={MODAL_TYPES.form}
      size={8}
      title='Parser Test Results'
      open
      actions={actions}
      {...props}>
      <Box>
        <Box mb={2}>
          <Typography variant='body1'>
            {numberPassingTests} / {parserTestResults.length} tests passed
          </Typography>
        </Box>
        <Box>
          {parserTestResults?.map(testResult => {
            return (
              <Box mb={2}>
                <TestResult parserTestResult={testResult} />
              </Box>
            )
          })}
        </Box>
      </Box>
    </ModalBase>
  )
}
